export const UNITTYPES_CREATE_EDIT_OPEN_MODAL = "UNITTYPES_CREATE_EDIT_OPEN_MODAL";

export const UNITTYPES_CREATE_REQUEST = "UNITTYPES_CREATE_REQUEST";
export const UNITTYPES_CREATE_RESULT = "UNITTYPES_CREATE_RESULT";

export const UNITTYPES_UPDATE_REQUEST = "UNITTYPES_UPDATE_REQUEST";
export const UNITTYPES_UPDATE_RESULT = "UNITTYPES_UPDATE_RESULT";

export const UNITTYPES_GET_REQUEST = "UNITTYPES_GET_REQUEST";
export const UNITTYPES_GET_RESULT = "UNITTYPES_GET_RESULT";